module.exports = __webpack_public_path__ + "img/wz-8-4-5.fefa42ea.jpg";